module.exports = __webpack_public_path__ + "media/audio34.1ac268b4.mp3";